// @ts-nocheck
export type PlaceQueries = {
  queries: string[]; // 2..8
  city_hint: string;
  banned_terms: string[];
  notes?: string[];
};

export async function synthesizePlaceQueries(input: {
  title?: string;
  description?: string;
  hashtags?: string[];
  ocr?: string[];
  cityHint?: string;
  language?: 'es' | 'en';
}): Promise<PlaceQueries> {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
  const fnBase = (process.env.REACT_APP_FUNCTIONS_BASE || '').replace(/\/$/, '');
  try {
    const endpoint = new URL(`${fnBase}/ai`, origin).toString();
    if (typeof window !== 'undefined') {
      try { console.info('[querySynthesis] endpoint', endpoint); } catch {}
    }
    const res = await fetch(endpoint, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-store',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ action: 'query-synth', input }),
    });
    if (!res.ok) throw new Error('synthesis_failed');
    return res.json();
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.warn('synthesizePlaceQueries fallback', e);
    return { queries: [], city_hint: input.cityHint || '', banned_terms: [], notes: [] };
  }
}
